import type { ReactNode } from 'react';

import { activatableProps } from '@/admin/components/activatable';
import styles from '@/admin/components/AdminCard.module.scss';

export const AdminCardList = ({ children }: { children: ReactNode }) => (
  <div className={styles.list}>{children}</div>
);

type AdminCardProps = {
  children: ReactNode;
  /** Makes the whole card open something; the controls inside it still act on their own. */
  onActivate?: () => void;
};

export const AdminCard = ({ children, onActivate }: AdminCardProps) => (
  <div
    className={`${styles.card} ${onActivate ? styles.interactive : ''}`}
    {...activatableProps(onActivate)}
  >
    {children}
  </div>
);
